module.exports = __webpack_public_path__ + "static/media/python.ae99c581.png";